import React from 'react';
import PaginationItem from './PaginationItem';

enum PaginationStage {
  Beginning = 'beginning',
  Middle = 'middle',
  End = 'end',
}

interface PageItemsExpandedProps {
  activePage: number;
  totalPages: number;
  limit: number;
  onPageChange: (page: number) => void;
}
const PageItemsExpanded: React.FC<PageItemsExpandedProps> = ({ activePage, totalPages, limit, onPageChange }) => {
  const paginationStage = (activePage: number, totalPages: number, limit: number) => {
    if (activePage >= 0 && activePage <= limit) return PaginationStage.Beginning;
    if (activePage > limit && activePage <= totalPages - limit) return PaginationStage.Middle;
    return PaginationStage.End;
  };

  const stage = paginationStage(activePage, totalPages, limit);

  if (stage === PaginationStage.Beginning) {
    return (
      <>
        <PaginationItem label="1" onClick={() => onPageChange(0)} isActive={activePage === 1} />
        <PaginationItem label="2" onClick={() => onPageChange(1)} isActive={activePage === 2} />
        <PaginationItem label="3" onClick={() => onPageChange(2)} isActive={activePage === 3} />
        <PaginationItem label="..." isActive={false} />
        <PaginationItem label={`${totalPages}`} onClick={() => onPageChange(totalPages - 1)} isActive={false} />
      </>
    );
  }
  if (stage === PaginationStage.Middle) {
    return (
      <>
        <PaginationItem label="1" onClick={() => onPageChange(0)} isActive={false} />
        <PaginationItem label="..." isActive={false} />
        <PaginationItem label={`${activePage - 1}`} onClick={() => onPageChange(activePage - 2)} isActive={false} />
        <PaginationItem label={`${activePage}`} onClick={() => onPageChange(activePage - 1)} isActive />
        <PaginationItem label={`${activePage + 1}`} onClick={() => onPageChange(activePage)} isActive={false} />
        <PaginationItem label="..." />
        <PaginationItem label={`${totalPages}`} onClick={() => onPageChange(totalPages - 1)} isActive={false} />
      </>
    );
  }
  return (
    <>
      <PaginationItem label="1" onClick={() => onPageChange(0)} isActive={false} />
      <PaginationItem label="..." isActive={false} />
      <PaginationItem label={`${totalPages - 4}`} onClick={() => onPageChange(totalPages - 5)} isActive={activePage === totalPages - 4} />
      <PaginationItem label={`${totalPages - 3}`} onClick={() => onPageChange(totalPages - 4)} isActive={activePage === totalPages - 3} />
      <PaginationItem label={`${totalPages - 2}`} onClick={() => onPageChange(totalPages - 3)} isActive={activePage === totalPages - 2} />
      <PaginationItem label={`${totalPages - 1}`} onClick={() => onPageChange(totalPages - 2)} isActive={activePage === totalPages - 1} />
      <PaginationItem label={`${totalPages}`} onClick={() => onPageChange(totalPages - 1)} isActive={activePage === totalPages} />
    </>
  );
};

export default PageItemsExpanded;
